// import { useEffect, useState } from 'react'
import classnames from 'classnames/bind'

// Components
import Skeleton from 'react-loading-skeleton'

// Styles
import styles from './style.module.scss'
import 'react-loading-skeleton/dist/skeleton.css'

const cx = classnames.bind(styles)

const ImageListSkeleton = () => {
  return (
    <div className={cx('image-list')}>
      {Array.from(Array(4)).map((_, index) => (
        <Skeleton key={index} height={'100%'} width={'100%'} containerClassName={cx('image-list-image')} />
      ))}
    </div>
  )
}

export default ImageListSkeleton
